import moment from 'moment-timezone';
import dateAndTimeMethods from 'utils/dateAndTimes/methods';
import getRules from 'utils/dateAndTimes/validators/getRules';

const getPickupDurationByNumberOfItems = (numberOfItems) => {
  if (numberOfItems >= 26) return 150;
  if (numberOfItems >= 21) return 120;
  if (numberOfItems >= 16) return 100;
  if (numberOfItems >= 11) return 80;
  if (numberOfItems >= 6) return 60;
  return 45;
};

const computeDropoffTimeFromWithRulesAndAvoidDiffDays = ({
  timesJoined,
  rules,
  pickup_duration,
}) =>
  timesJoined.pickup_time_from.clone().add(pickup_duration, 'minutes') >
  rules.dropoff_time_from.min.value.clone()
    ? moment.min(
        timesJoined.pickup_time_from.clone().add(pickup_duration, 'minutes'),
        rules.dropoff_time_from.min.value
          .clone()
          .add(pickup_duration, 'minutes')
      )
    : rules.dropoff_time_from.min.value.clone();

const getRulesWithRestrictions = ({
  times,
  isForSuggestions,
  timeWindow,
  restrictions,
}) => {
  const rules = getRules(times, isForSuggestions);
  const timesJoined = dateAndTimeMethods.joinTimesWithDates(times);
  const pickup_duration = timeWindow
    ? timeWindow.travel_time / 60 + timeWindow.pickup_time / 60
    : getPickupDurationByNumberOfItems(
        restrictions?.maxNumberOfItemsInLoadsBetweenShipments
      );

  // We prioritize the drop-off min date times by taking the time window if defined
  try {
    return {
      ...rules,
      dropoff_time_from: {
        ...rules.dropoff_time_from,
        min: {
          ...rules.dropoff_time_from.min,
          value: timeWindow?.dropoff_time_from_min
            ? moment(timeWindow.dropoff_time_from_min)
            : computeDropoffTimeFromWithRulesAndAvoidDiffDays({
                timesJoined,
                rules,
                pickup_duration,
              }), // moment(timesJoined.pickup_time_from) replace it. This is for collections,
        },
      },
      dropoff_time_to: {
        ...rules.dropoff_time_to,
        min: {
          ...rules.dropoff_time_to.min,
          value: moment.max(
            computeDropoffTimeFromWithRulesAndAvoidDiffDays({
              timesJoined,
              rules,
              pickup_duration,
            }),
            rules.dropoff_time_to.min.value
          ),
        },
      },
    };
  } catch (err) {
    console.log('error', err);
    return rules;
  }
};

export default getRulesWithRestrictions;
